import {
    StoragePartition,
    StoragePartitionKeys,
} from '@amzn/event-engine-js-utils';
import { useCallback } from 'react';

export enum StorageKey {
    ParticipantID = 'participantId',
}

const useEventParticipant = () => {
    const getParticipant = useCallback(
        () =>
            (StoragePartition.getItem(
                StoragePartitionKeys.eventParticipant,
                StorageKey.ParticipantID
            ) as string) || null,
        []
    );
    const setParticipant = useCallback(
        (participantId: string | null) =>
            StoragePartition.setItem(
                StoragePartitionKeys.eventParticipant,
                participantId,
                StorageKey.ParticipantID
            ),
        []
    );
    const clearParticipant = useCallback(() => {
        setParticipant(null);
    }, []);

    return {
        getParticipant,
        setParticipant,
        clearParticipant,
    };
};

export default useEventParticipant;
